import { render, staticRenderFns } from "./CaptureModal.vue?vue&type=template&id=0c2a45f8&scoped=true"
import script from "./CaptureModal.vue?vue&type=script&lang=ts"
export * from "./CaptureModal.vue?vue&type=script&lang=ts"
import style0 from "./CaptureModal.vue?vue&type=style&index=0&id=0c2a45f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a45f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VIcon,VLayout})
